export const validation = {
  adjustment: {
    maxTwoDecimals: 'Debe contener como máximo 2 decimales',
  },
};
